<template>
  <v-form
    class="bg-light py-md-3 py-1 px-3 rounded mb-1"
    @submit.prevent="submit()"
  >
    <div class="row">
      <div class="col-1">
        ID: {{ quiz.id }}
      </div>
      <div class="col-1">
        {{ lookup.languages.find(obj => (obj.id == quiz.language_id)).name }}
      </div>
      <div class="col-2">
        <div class="pb-0">
          <v-text-field
            v-model="quiz.name"
            variant="outlined"
            density="compact"
            bg-color="white"
            label="Trackable ID*"
            :error-messages="v$.quiz.name.$errors.map((e) => e.$message)"
            @blur="v$.quiz.name.$touch()"
          />
        </div>
      </div>
      <div class="col-2">
        <div class="pb-0">
          <v-text-field
            v-model="quiz.description"
            variant="outlined"
            density="compact"
            bg-color="white"
            label="Name*"
            :error-messages="v$.quiz.description.$errors.map((e) => e.$message)"
            @blur="v$.quiz.description.$touch()"
          />
        </div>
      </div>
      <div class="col-2">
        <div class="pb-0">
          <v-text-field
            v-model="quiz.pass_score"
            variant="outlined"
            density="compact"
            bg-color="white"
            label="Pass Score*"
            type="number"
            :error-messages="v$.quiz.pass_score.$errors.map((e) => e.$message)"
            @blur="v$.quiz.pass_score.$touch()"
          />
        </div>
      </div>
      <div class="col-2">
        <div class="pb-0">
          <v-text-field
            v-model="quiz.total_questions"
            variant="outlined"
            density="compact"
            bg-color="white"
            label="Total Questions*"
            type="number"
            :error-messages="v$.quiz.total_questions.$errors.map((e) => e.$message)"
            @blur="v$.quiz.total_questions.$touch()"
          />
        </div>
      </div>
      <div class="col-1">
        <div class="pb-0">
          <v-checkbox
            v-model="quiz.public"
            value="Y"
            unchecked-value="N"
          >
            Public
          </v-checkbox>
        </div>
      </div>

      <div class="col-1">
        <button
          type="submit"
          class="btn btn-default btn-sm"
          :disabled="isLoading"
        >
          Save <span
            v-show="isLoading"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          />
        </button>
      </div>
    </div>
  </v-form>
  <v-snackbar
    v-model="isSnackbarOpen"
    :timeout="3000"
    location="top right"
  >
    <v-alert
      color="#dfe8e8"
      :title="title"
      :text="message"
    />
  </v-snackbar>
</template>

<script>
import axios from 'axios';
import { useVuelidate } from '@vuelidate/core';

import { lookup } from '../lookup/lookup';

import { appValidator } from '../../common/core/utils/validator';

export default {
  props: ['modelValue', 'index'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      quiz: { ...this.modelValue },
      lookup,
      isLoading: false,
      isSnackbarOpen: false,
      message: '',
      title: '',
    };
  },

  validations() {
    return {
      quiz: {
        name: {
          required: appValidator.required,
        },
        description: {
          required: appValidator.required,
        },
        pass_score: {
          required: appValidator.required,
        },
        total_questions: {
          required: appValidator.required,
        },
      },
    };
  },

  methods: {

    validate() {
      let error = false;
      if (this.v$.$invalid) {
        this.v$.$touch();
        error = true;
      }

      return !error;
    },

    async submit() {
      if (!this.validate()) {
        return;
      }

      this.isLoading = true;
      const response = await axios.put(
        `/api/elearning/quizzes/${this.quiz.id}`,
        this.quiz,
      );
      this.isLoading = false;
      this.openSnackbar('Saved', this.quiz.description);

      // this.$emit('input', this.user);
    },
    openSnackbar(title, message) {
      this.isSnackbarOpen = true;
      this.title = title;
      this.message = message;
    },
  },
};
</script>
